/**
 * [resp-img]
 * responsive images via data-resp-img-* attributes
 */
window.coma = window.coma || {};

window.coma.teaser = (function ($, undefined) {

    // PRIVATE FUNCTIONS
    var _private = {

        init: function() {
            // listen to mediaqueries-changed
            $(document).on('mediaqueries-changed', function(e) {
                // the new mediaquery (xs, sm, md, lg) is stored in e.message
                _private.delayTeaserHeight();
            });

            // initially do it once
            _private.delayTeaserHeight();
        },
        delayTeaserHeight: function() {
            // wait for all teaser images to be loaded
            setTimeout(function() {
                _private.setTeaserHeight();

                // still waiting
                setTimeout(function() {
                    _private.setTeaserHeight();

                    // buy a faster internet connection
                    setTimeout(function() {
                        _private.setTeaserHeight();
                    }, 6000);

                }, 4000);

            }, 200);
        },
        setTeaserHeight: function() {
            var mediaquery = window.coma.mediaqueries.getDevice();
            // reset all teasers to auto height
            $('.teaser').find('li').css('height', 'auto');

            switch (mediaquery) {
                case 'sm':
                case 'md':
                    // TWO IN A ROW, so set their heights to the maxHeight
                    $.each($('.teaser').find('li:nth-child(2n+1)'), function(index, value) {
                        var $next = $(this).next();
                        if ($next.length) {
                            var maxHeight = Math.max($(this).height(), $next.height());
                            $(this).height(maxHeight);
                            $next.height(maxHeight);
                        }
                    });
                    break;
                case 'lg':
                    // THREE IN A ROW, so set their heights to the maxHeight
                    $.each($('.teaser').find('li:nth-child(3n+1)'), function(index, value) {
                        var $next = $(this).next();
                        var $afterNext = $next.next();

                        if ($next.length) {
                            var maxHeight = Math.max($(this).height(), $next.height());
                            $(this).height(maxHeight);
                            $next.height(maxHeight);

                            if ($afterNext.length) {
                                maxHeight = Math.max(maxHeight, $afterNext.height());
                                $(this).height(maxHeight);
                                $next.height(maxHeight);
                                $afterNext.height(maxHeight);
                            }
                        }
                    });
                    break;
            }
        }
    }

    // CALL INIT
    $(document).ready(function() {
        _private.init();
    });

    $( window ).load(function() {
        _private.setTeaserHeight();
    });

    // PUBLIC FUNCTIONS
    return {}

}(jQuery));